import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { CDialog } from '@appcues/component-library';
import authClient from 'auth-client';
import { showToast } from 'actions/toaster';
import { reportError } from 'helpers/error-reporting';

export function ConfirmResetPasswordModal({ actions, email }) {
  const onClickResetPassword = () => {
    return authClient
      .resetPassword(email)
      .then(() => {
        actions.showToast({ message: 'Password reset email sent.' });
        actions.hideModal();
      })
      .catch(error => {
        reportError(error);
        actions.showToast({
          message: 'Password reset email could not be sent.',
        });
      });
  };

  return (
    <CDialog
      type="primary"
      title="Confirm reset password"
      primaryActionText="Reset password"
      onSecondaryAction={actions.hideModal}
      onPrimaryAction={onClickResetPassword}
    >
      We&apos;ll send you an email with instructions on how to reset your
      password.
    </CDialog>
  );
}

ConfirmResetPasswordModal.propTypes = {
  actions: PropTypes.shape({
    hideModal: PropTypes.func.isRequired,
    showToast: PropTypes.func.isRequired,
  }).isRequired,
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  actions: {
    ...ownProps.actions,
    ...bindActionCreators(
      {
        showToast,
      },
      dispatch
    ),
  },
});

export default connect(null, mapDispatchToProps)(ConfirmResetPasswordModal);
